import './PageList.css';
import React, {useEffect, useState} from 'react';

/**
 * Renders a list of page numbers for pagination.
 *
 * @param {Object} props - The properties object.
 * @param {number} props.page - The current page number.
 * @param {number} props.lastPage - The last page number.
 * @param {number} props.countPages - The total count of pages.
 * @param {Function} props.onChange - The function to be called when a page number is clicked.
 *
 * @return {JSX.Element} The rendered page list component.
 */
function PageList(props) {

  function onClick(pageNumber) {
    props.onChange(pageNumber);
  }

  const pageNumbers = (start, end) => {
    let pages = [];

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  const listEnd = Math.min(props.countPages, props.lastPage)

  return (
      <ul id={'page-list'}>
        {
          props.firstPage > 1 ?
              <>
                <li key="firstPage">
                  <a href={`#`} onClick={event => {
                    event.preventDefault();
                    onClick(1);
                  }}>1</a>
                </li>
                <li key="ellipsis1">...</li>
              </> :
              <></>
        }
        {
          pageNumbers(props.firstPage, listEnd).map(pagePoint => {
            if (pagePoint === props.page) {
              return <li key={`page_${pagePoint}`} className="active">
                <span>{pagePoint}</span>
              </li>;
            } else if (pagePoint === 1 && !props.savePage) {
              return <li key={`page_${pagePoint}`}>
                <a href={`#`} onClick={event => {
                  event.preventDefault();
                  onClick(pagePoint);
                }}>{pagePoint}</a>
              </li>;
            } else {
              return <li key={`page_${pagePoint}`}>
                <a href={`#`} onClick={event => {
                  event.preventDefault();
                  onClick(pagePoint);
                }}>{pagePoint}</a>
              </li>;
            }
          })
        }
        {
          props.countPages > props.lastPage ?
              <>
                <li key="ellipsis2">...</li>
                <li key={`lastPage`}>
                  <a href={`#`}
                     onClick={event => {
                       event.preventDefault();
                       onClick(props.countPages);
                     }}>{props.countPages}</a>
                </li>
              </> :
              <></>
        }
      </ul>
  );
};

export default PageList;